// API Configuration for different environments
const getApiUrl = () => {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'http://localhost:8080';
  }
  
  // For production, use environment variable or relative URL
  return process.env.REACT_APP_API_URL || window.location.origin;
};

const getApiBaseUrl = () => {
  const baseUrl = getApiUrl();
  return `${baseUrl}/api/v1`;
};

export const API_BASE_URL = getApiBaseUrl();

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/auth/login`,
  CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
  
  // User endpoints
  USERS: `${API_BASE_URL}/users`,
  ADMIN_USERNAMES: `${API_BASE_URL}/admin/usernames`,
  ADMIN_USERS: `${API_BASE_URL}/admin/users`,
  VACATION_BALANCE: `${API_BASE_URL}/vacation-balance`,
  
  // Work status endpoints
  WORK_STATUS: `${API_BASE_URL}/work-status`,
  WORK_STATUS_BATCH: `${API_BASE_URL}/work-status/batch`,
  ADMIN_WORK_STATUS: `${API_BASE_URL}/admin/work-status`,
  ADMIN_WORK_STATUS_BATCH: `${API_BASE_URL}/admin/work-status/batch`,
    
  // Collective vacation endpoints
  COLLECTIVE_VACATION: `${API_BASE_URL}/collective-vacation`,
  ADMIN_COLLECTIVE_VACATION: `${API_BASE_URL}/admin/collective-vacation`,
  
  // Holiday endpoints
  HOLIDAYS: `${API_BASE_URL}/holidays`,
  
  // Year status endpoints
  YEAR_STATUS: `${API_BASE_URL}/year-status`,
  CLOSE_YEAR: `${API_BASE_URL}/admin/close-year`,
  CARRYOVER_SETTINGS: `${API_BASE_URL}/admin/settings/carryover`,
  
  // Monthly report endpoints
  MONTHLY_REPORT_DOWNLOAD: `${API_BASE_URL}/admin/reports/monthly`,
  MONTHLY_REPORT_PREVIEW: `${API_BASE_URL}/admin/reports/monthly/preview`,
};

// Helper function to build dynamic URLs with parameters
export const buildUrl = (endpoint, params = {}) => {
  let url = endpoint;
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  return url;
};

// Helper function for query parameters
export const addQueryParams = (url, params = {}) => {
  const urlObj = new URL(url);
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      urlObj.searchParams.append(key, params[key]);
    }
  });
  return urlObj.toString();
};

// Helper function for dynamic endpoints that need IDs
export const getEndpointWithId = (baseEndpoint, id) => {
  return `${baseEndpoint}/${id}`;
};

// Helper function for date ranges in collective vacation endpoints
export const getCollectiveVacationUrl = (startDate, endDate) => {
  return addQueryParams(API_ENDPOINTS.COLLECTIVE_VACATION, {
    start_date: startDate,
    end_date: endDate
  });
};

// Export commonly used patterns
export const API_PATTERNS = {
  // User management
  DELETE_USER: (id) => getEndpointWithId(API_ENDPOINTS.ADMIN_USERS, id),
  UPDATE_USER: (id) => getEndpointWithId(API_ENDPOINTS.ADMIN_USERS, id),
  
  // Collective vacation management
  DELETE_COLLECTIVE_VACATION: (id) => getEndpointWithId(API_ENDPOINTS.ADMIN_COLLECTIVE_VACATION, id),
  GET_COLLECTIVE_VACATION_RANGE: (startDate, endDate) => getCollectiveVacationUrl(startDate, endDate),
};
